import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=cc9ffd3c&scoped=true&"
import script from "./PhoneInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=cc9ffd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9ffd3c",
  null
  
)

export default component.exports